<template>
	<div class="storepurchase">
		<Qrcode-Dialog :instockdia.sync="instockdia" :maincusCode="maincusCode"/>
		<div class="header-top">
			<div style="font-size:18px;padding-top:10px">{{$t('other.a2733')}}：{{itemsCount}} {{$t('userStoreItems').ppo}}</div>
			<div class="query-list">
				<div class="query-list-tcp">
					<div style="width: 150px;">
						<el-select @change="getShopItems(warehouseId)" v-model="warehouseId" :placeholder="warehouseOption[0].value" >
							<el-option v-for="item in warehouseOption" :key="item.storeId" :label="item.value" :value="item.label">
							</el-option>
						</el-select>
					</div>
					<div style="width: 150px;margin:0 5px;">
						<el-select @change="getShopItems()" v-model="componentValue" :placeholder="warehouseOption[0].value" >
							<!-- <el-option  :label="$t('other.a358')" value="null"></el-option> -->
							<el-option  :label="$t('other.a2734')" value="1"></el-option>
							<el-option  :label="$t('other.a1341')" value="2"></el-option>
							<el-option  :label="$t('other.a2735')" value="3"></el-option>
						</el-select>
					</div>
					<div style="width: 150px;margin:0 5px;">
						<el-select @change="getShopItems()" v-model="SelllerValue" :placeholder="$t('other.a2736')" >
							<el-option
								v-for="item in sellerList"
								:key="item.value"
								:label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>
					<div class="query-list-bbc">
						<el-input style="width:250px"  clearable  :placeholder="$t('userStoreItems').search_tip" v-model="cusCode"></el-input>
						<el-button style="margin: 0 5px" size="mini" type="primary" @click="getShopItems()">{{$t('userStoreItems').search}}</el-button>
					</div>
					<div style="margin-left:15px">
						<el-tooltip class="item" effect="dark" :content="$t('other.a2737')" placement="bottom-end">
							<el-button  type="primary" @click="goToABC()">{{$t('other.a2738')}}</el-button>
						</el-tooltip>
					</div>
				</div>
			
			</div>
	
		</div>
		
		
		
		<div class="mygoods-list">
			<div class="mygoods-list-nodata" v-if="!userStormList.length " >--{{$t('userStoreItems').nodata}}--</div>
			<div v-else>
				
				<div v-for="(item,index) in userStormList" :key="index" >
					<div class="list-item">
						<el-row>
							<el-col :span="24">
								<div class="item-view">
									
									<div class="goods-pic"><img v-image-preview :src="changeImgURL(item.image)"></div>
									<div class="goods-desc">
										
										<div style="width:200px;">
											<div >
												<div>{{item.itemName}}</div>
											</div>
											<div class="skuName">
												<div >sku：{{item.skuName}}</div>
											</div>
										</div>
										<div class="goods-title-desc">
											<div class="goods-item">{{$t('userStoreItems').shop}}：{{item.shopName}}</div>
											<div class="goods-item">{{$t('userStoreItems').userName}}：{{item.userName}}</div>
											<div class="goods-item">{{$t('userStoreItems').warehouse}}：{{item.storeName}}</div>
											<div class="goods-item">
												<div >{{$t('userStoreItems').cost}}：{{item.cost}}</div>
											</div>
										</div>
										<div class="goods-title-desc">
											<div >{{$t('userStoreItems').cusCode}}：{{item.cusCode}}</div>
											<div >{{$t('userStoreItems').shipping_stock}}：{{item.unShipped}}</div>
											<div >{{$t('other.a2538')}}：{{item.auditedStock}}</div>
											<div>
												<span  v-show="!item.checked">{{$t('userStoreItems').total_stock}}：{{item.storeNum}}</span>
												<span  v-show="item.checked">{{$t('userStoreItems').total_stock}}：<input style="width: 40px;" size="mini" v-model="item.storeNum"></input></span>
												<i  style="margin-left: 15px;color: #409EFF;font-size: 16px;cursor: pointer;" v-show="!item.checked && (componentValue == '2' || componentValue == '3')"  @click="nnfnv(item,0)" class="el-icon-edit " ></i>
												<el-button style="margin-left: 15px;" v-show="item.checked"  @click="nnfnv(item,1)" size="mini" type="danger">{{$t('other.a145')}}</el-button>
											</div>
											
										</div>
										<div class="goods-title-desc">
											<div>
												<div v-if="isEdit !== index">{{$t('other.a2739')}}：{{item.packageLength}}*{{item.packageWidth}}*{{item.packageHeight}} cm</div>
												<div v-if="isEdit == index">{{$t('other.a2739')}}：<input style="width: 40px;" size="mini" v-model="item.packageLength"></input>*
												 <input style="width: 40px;" size="mini" v-model="item.packageWidth"></input>*
												 <input style="width: 40px;" size="mini" v-model="item.packageHeight"></input>cm
												</div>
											</div>
											
											<div >
												<div v-if="isEdit !== index">{{$t('other.a2153')}}：{{item.weight }} kg</div>
												<div v-if="isEdit == index">{{$t('other.a2153')}}：<input style="width: 40px;padding:0px" v-model="item.weight"></input> kg</div>
											</div>
											<div >
												<div v-if="isEdit !== index">{{$t('other.a1169')}}：{{item.address ? item.address : $t('other.a140')}}</div>
												<div v-else>{{$t('other.a1169')}}：<input style="width: 40px;" size="mini" v-model="item.address"></input></div>
											</div>
										</div>
									</div>
									<div class="btn-wrapper">
									
										<div class="btn-item-desc" v-if="isEdit !== index">
											<el-button v-show="componentValue == '2' || componentValue == '3'" style="width: 120px;" type="primary" size="mini" icon="el-icon-edit" @click.stop="handleEditStreet(index)">{{$t('userStoreItems').edit}}</el-button>
										</div>
										<div class="btn-item-desc" v-else>
											<el-button v-show="componentValue == '2' || componentValue == '3'" style="width: 120px;" type="danger"  size="mini" icon="el-icon-edit" @click.stop="confirm(item)">{{$t('userStoreItems').confirmBtn}}</el-button>
										</div>
										<div class="btn-item-desc" >
											<el-button style="width: 120px;" type="primary"  size="mini"  @click.stop="viewstoreoperaterecord(item)">{{$t('other.a2558')}}</el-button>
										</div>
									
									</div>
									
								</div>
							</el-col>
						</el-row>
						
					</div>
				</div>
				<!-- 分页器 -->
				<div class="Pager">
				    <el-pagination
				      @size-change="handleSizeChange"
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-sizes="[15, 20, 30, 50]"
					:page-size="15"
					layout="total, sizes, prev, pager, next, jumper"
					:total="itemsCount">
				    </el-pagination>
				  </div>
			</div>
			
		</div>
	</div>
</template>

<script>
	import api from '../../api/api.js'
	import QrcodeDialog from '../../components/dialog/qrcodeDialog.vue'
	import utils from '../../utils/utils'
	import {
		mapState,
		mapActions
	} from 'vuex'
	export default {
		data() {
			return {
				warehouse: JSON.parse(localStorage.getItem('warehouse')),
				userShops: JSON.parse(localStorage.getItem('shopIdInfo')),
				userInfo: JSON.parse(localStorage.getItem('userInfo')),
				allStoreId:JSON.parse(localStorage.getItem('userInfo')).storeIds,
				allShopId:[],
				sellerList:null,
				warehouseOption:[],
				warehouseId: '',
				chosedStore: '',
				itemNameQuery: '',
				statusValue: '',
				isChooseList: [],
				bindItemList: [],
				caigouTable: false,
				bindTable: false,
				count: 0,
				dialogVisible: false,
				remindDialog: false,
				itemCount: 0,
				arr: [],
				isBindItemModel: false,
				sellerMessage: "",
				visiableMessage: '',
				stockRemindList: [],
				instockdia:false,
				maincusCode:0,
				remindCount: 0,
				selectShop: '',
				currentPage:0,
				offset:15,
				isEdit:-1,
				componentValue:'2',
				commfire:true,
				dialogTableVisible:false,
				autosize:{
					minRows: 2
				},
				cusCode:'',
				SelllerValue:'all',
				getDataParams:{

				}
				
			}
		},
		components: {
			QrcodeDialog,
			
		},
		computed: {
			...mapState({
				mygoodslist: state => state.mygoods.mygoodslist,
				userId: state => state.shopaccess.userInfo.userId,
				userStormList: state => state.userStoreItems.userStormList,
				itemsCount: state => state.userStoreItems.itemsCount,
				bindItemList01: state => state.userStoreItems.bindItemList01,
				deleTip: state => state.userStoreItems.deleTip,
			
				
			}),
			
			remindList() {
				return this.stockRemindList;
			},
			
		},
		watch:{
			cusCode(){
				if(this.cusCode === "")
				this.getShopItems()
			},
			
		},
		created(){
			this.ttp()
			
		},
		methods: {
			...mapActions('userStoreItems', [
				'getStoreItemBystore',
				'createCaiGouTable',
				'viewBindItems',
				'deleStoreItems',
				'jiebanItems',
				'updateItemInfo',
				'storeUpdateStoreNumAndAddress',
				'updateStoreNumBystore',
				'getInstockoperaterecore'
				]),
				
				
				
				
				// //搜索商品名称查找
				// goTosearch(){
				//  this.getShopItems()
				// },
				jiebang(index){
					let arr=this.bindItemList01
					if(arr.length === 1) {
						alert(this.$t('other.a2740'))
						return
					}
					console.log(this.bindItemList01)
					console.log(index)
					this.jiebanItems(index)
				},
				deleStoreItem(code) {
					let param={
						cusCode:code
					}
					this.deleStoreItems(param)
				
				},
			
			opendialogTableVisible(code){
				const param={
				   cusCode:code,
				   userId:this.userId
				}
				
				this.dialogTableVisible=true
				this.viewBindItems(param)
			},
			//控制每页显示订单条数
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
				this.offset=parseInt(`${val}`)
				this.handleCurrentChange()
			  },
			  //显示当前第几页
			  handleCurrentChange(val) {
					const params={
						offset:this.offset,
						page:(parseInt(`${val}`) -1) * this.offset,
						userId:this.userId,
						storeId:this.warehouseId,
						component:this.componentValue == 'null' ? null :this.componentValue == '2' ? true : false,
						sellerId:this.SelllerValue == 'all'? '' : this.SelllerValue,
						cusCode:''
					}
						console.log(params)
						this.getStoreItemBystore(params)
			  },
			  stockTotal(num1,num2) {
				  return num1 + num2
			  },
			  ttp(){
				
				JSON.parse(localStorage.getItem('userInfo')).sellers.forEach(p => {
					p.shopIds.forEach(k => {
						this.allShopId.push(k)
					})
				})

					console.log('shopId',this.allShopId)
				this.warehouse.forEach(item => {
					let oop={
						label:item.storeId,
						value:item.storeName + "(" + item.userName + ")"
					}
					this.warehouseOption.push(oop)
				})
				this.warehouseId=this.warehouseOption[0].label
				this.getDataParams={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:JSON.parse(localStorage.getItem('userInfo')).storeIds[0],
					component:this.componentValue == 'null' ? null :this.componentValue == '2' ? true : false,
					sellerId:null,
					cusCode:''
				}
				this.sellerList=JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {
					return {
						label:p.userName,
						value:p.userId
					}
				})

				this.sellerList.unshift({
					label:this.$t('other.a1571'),
					value:'all'
				})

				

				//  console.log("选中仓库下的商品",params)
				 this.getStoreItemBystore(this.getDataParams)
			},
			handleEditStreet(index){
				console.log(index)
				this.isEdit =index
				
			},
			
			nnfnv(item,num){
				if(num == 0){
					item.checked=true
				}else if(num == 1){
					let params={
						cusCode:item.cusCode,
						storeNum:Number(item.storeNum),
					}
					console.log(params)
					this.updateStoreNumBystore(params)
					item.checked=false
				}
			},
			confirm(item){
				// if(!this.store01) {
				// 	this.$message.success("请输入库存，仅能是整数！")
				// 	this.isEdit=-1
				// 	return
				// }
				// item.storeNum=this.store01 
				item.userId=this.userId
				console.log(item)
				this.storeUpdateStoreNumAndAddress(item)
				this.isEdit=-1
				this.store01=''
			},
			suggest() {
				this.remindDialog = true;
			},
		
			changeImgURL(url) {
				return url
			},
			getShopNmae(shopId) {
				return this.userShops.find(shop => shop.shopId == shopId).shopName;
			},
			getVariantNmae(row) {
				if (row.variationId == 0 || row.variationId == '') return ""
				return row.item.variations.find(variation => variation.variationId == row.variationId).name;
			},
			addBindToList(item, variation) {
				if (variation == null) {
					variation = {
						variationId: 0
					}
				}
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "shopId", this.shipId);
				this.$set(param, "variation", variation);
				let isInList = false;
				for (let i = 0; i < this.bindItemList.length; i++) {
					if (this.bindItemList[i].itemId == param.itemId) {
						if (!this.bindItemList[i].hasVariation && !param.hasVariation) isInList = true;
						if (this.bindItemList[i].hasVariation && param.hasVariation &&
							this.bindItemList[i].variation.variationId == param.variation.variationId) isInList = true;
					}

				}
				if (!isInList) this.bindItemList.push(param);
				this.itemCount = this.bindItemList.length
				console.log(this.bindItemList)
			},
			commitBind() {
				let param = [];
				for (let i = 0; i < this.bindItemList.length; i++) {
					let binditem = {
						itemId: this.bindItemList[i].itemId,
						shopId: this.bindItemList[i].shopId,
						variationId: this.bindItemList[i].variation.variationId
					}
					param.push(binditem);
				}
				console.log(param);
				api.bindItem(param).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.dialogVisible = true;
						this.visiableMessage = this.$t('other.a2732')
						this.bindTable = false;
					}
				})
			},
			deleteChoose(item) {
				console.log(item)
				var index = this.isChooseList.findIndex(choose => {
					if (choose.itemId == item.itemId && choose.variation.variationId == item.variation.variationId) {
						return true
					}
				})
				this.isChooseList.splice(index, 1);
				this.count = this.isChooseList.length;
			},

			viewstoreoperaterecord(item){
				this.instockdia=true
				this.maincusCode=item.cusCode
				let params={
					cusCode:item.cusCode,
					end:utils.getchinastadarTime(0),
					start:utils.getchinastadarTime(-7),
					offset:50,
					page:0,
					userId:this.userId
				}
				console.log(params)
				this.getInstockoperaterecore(params)
			},
			getShopItems() {
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:this.warehouseId,
					cusCode:this.cusCode,
					addition:this.componentValue == '3' ? true : false,
					component:this.componentValue == 'null' ? null :this.componentValue == '2' ? true : false,
					sellerId:this.SelllerValue == 'all'? '' : this.SelllerValue
				}
				 console.log("选中仓库下的商品",params)
				 this.getStoreItemBystore(params)
			},
			getShopItems001() {
				
				const params={
					offset:this.offset,
					page:this.currentPage,
					userId:this.userId,
					storeId:'',
					cusCode:''
				}
				 console.log("选中仓库下的商品",params)
				 this.getStoreItemBystore(params)
			},
			updateFromShopee() {
				if (this.selectShop == '') {
					this.showMessage(this.$t('other.a1917'))
				} else {
					api.updateItems(this.selectShop).then(res => {
						if (res.code === 200) {
							this.showMessage(this.$t('other.a1918'))
							this.getShopAllItems(this.selectShop)
						}
					})
				}
			},
			//创建采购单
			createOrder() {
				let variantList = [];
				let chooseList = this.isChooseList;
				if (chooseList.length == 0) {
					this.showMessage(this.$t('other.a2112'));
					return;
				}
				
				for (let i = 0; i < chooseList.length; i++) {
					if (chooseList[i].num == 0) {
						this.showMessage(this.$t('other.a2114'));
						return;
					}else if(chooseList[i].storeId !== chooseList[0].storeId) {
						this.showMessage(this.$t('other.a2115'))
						return 
					}
					let variation = {
						anotherName: chooseList[i].anotherName,
						cost: chooseList[i].cost,
						cusCode: chooseList[i].cusCode,
						image: chooseList[i].image,
						item_id: chooseList[i].itemId,
						itemName: chooseList[i].itemName,
						variantName: chooseList[i].variation.name,
						variant_num: chooseList[i].num,
						variant_id:chooseList[i].variation.variationId,
					}
					variantList.push(variation);
				}
				console.log(variantList)
				let param = {
					message_to_seller: this.sellerMessage,
					storeId: chooseList[0].storeId,
					userId: chooseList[0].userId,
					variantList: variantList
				}
				console.log('hhh',param)
				
				api.createPurchaseOrder(param)
					.then(res => {
						if (res.code === 200) {
							console.log(res.data)
							this.showMessage(this.$t('other.a2741') + res.data.purchaseOrderId);
							this.caigouTable = false;
							this.isChooseList=[]
							this.count=0
						}
				})
			},
			showMessage(massage) {
				this.dialogVisible = true;
				this.visiableMessage = massage;
			},
			choseStatus(value) {
				console.log(value)
			},
			handleBtn() {
				console.log(this.userStormList)
			},
			getTime(time) {
				let ttp = time.slice(0, time.indexOf('T'))
				let ccp = time.slice(time.indexOf('T') + 1, time.indexOf('.'))
				return ttp + ' ' + ccp
			},
			//状态转换
			conversionStatus(ttp) {

				return this.status[ttp]
			},
			unique(arr, type) { // 根据唯一标识orderId来对数组进行过滤
				const res = new Map(); //定义常量 res,值为一个Map对象实例
				//返回arr数组过滤后的结果，结果为一个数组   过滤条件是，如果res中没有某个键，就设置这个键的值为1
				if (type == 'loupan') {
					return arr.filter((arr) => !res.has(arr.bizid) && res.set(arr.bizid, 1))
				} else {
					return arr.filter((arr) => !res.has(arr.code) && res.set(arr.code, 1))
				}
			},
			goToABC(){
				    let storeList=JSON.parse(localStorage.getItem('userInfo')).stores.filter(p => {
						if(p.storeType == 2){
							return p
						}
					})
					console.log(storeList) 
					let router = this.$router.resolve(
					  { 
					    name: "treemap" ,
						query:{
							storeId:'10100002'
						}
					  }
					);
					window.open(router.href, '_blank');
				},
			tocaiguo() {
				api.getSellerStore(this.userInfo.userId).then(res => {
					if (res.code === 200) {
						console.log(res.data)
						this.storeList = [];
						for (let i = 0; i < res.data.length; i++) {
							this.storeList.push({
								value: res.data[i].storeId,
								label: res.data[i].storeName + '(' + res.data[i].userName + ')'
							})
						}
						this.chosedStore = '';
					}
				});
				this.caigouTable = true;
			},
			tobindItem() {
				this.bindTable = true;
			},
			targetVariation(item, variation) {
				
				let param = JSON.parse(JSON.stringify(item));
				this.$set(param, "num", 0);
				this.$set(param, "anotherName", "");
				this.$set(param, "variation", variation == null ? {
					variationId: 0,
					name: '',
					stock: 0
				} : variation)
				let isInList = false;
				for (let i = 0; i < this.isChooseList.length; i++) {
					if (this.isChooseList[i].cusCode === param.cusCode){
						isInList = true;
						}
				}
				if (!isInList) this.isChooseList.push(param);
				this.count = this.isChooseList.length
				console.log('选中需要采购的商品',this.isChooseList)
			},
			cleanForm() {
				this.isChooseList = [];
				this.sellerMessage = '';
			},
			cleanBind() {
				this.bindItemList = [];
			},
			
			getStoreName(num){
				let ttp=null
				this.warehouse.forEach(item => {
					if(item.storeId === num)
					ttp=item
				})
				
				return ttp.userName
			}


		}
	}
</script>


	<style scoped>
		.storepurchase .demo-table-expand {
			font-size: 0;
		}
	
		.storepurchase .demo-table-expand label {
			width: 120px;
			color: #99a9bf;
		}
	
		.storepurchase .demo-table-expand .el-form-item {
			margin-right: 0;
			margin-bottom: 0;
			width: 50%;
		}
	
		.storepurchase {
			flex: 1;
			padding: 60px 0 0 221px;
			overflow: hidden;
		}
	
		.storepurchase .el-dialog__body {
			padding-top: 0px;
		}
	
		.storepurchase .list-item {
			justify-content: space-around;
			align-items: center;
			margin: 5px;
			
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}
	
		.storepurchase .list-variation {
			justify-content: space-around;
			align-items: center;
		}
	
		.storepurchase .item-view {
			display: flex;
			justify-content: space-around;
			align-items: center;
			box-sizing: border-box;
			padding: 10px 5px;
			box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
		}
	
		.storepurchase .variation-list {
			justify-content: space-around;
			align-items: center;
		}
	
		.storepurchase .el-collapse-item__content {
			padding: 0rem;
		}
	
		.storepurchase .goods-pic {
			width: 80px;
			height: 80px;
		}
	
		.storepurchase .el-dialog__body {
			padding-bottom: 0px !important;
		}
	
		img {
			width: 100%;
		}
		
		.storepurchase .yihdf{
			display: flex;
		}
		
		.storepurchase .allChosee{
			padding-left: 20px;
		}
	
		.storepurchase .el-collapse-item__header {
	
			float: right;
		}
	
		.storepurchase .goods-desc {
			display: flex;
			margin-left: 10px;
		}
	
		.storepurchase .goods-item {
			
			width:155px;
			margin: 0px 10px;
			color: #00193A;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
			
		}

		.storepurchase .goods-btn {
			display: inline-block;
			margin: 7px 10px;
		}
		
	
		.storepurchase .goods-title {
			width: 500px;
			color: red;
		}
	
		.storepurchase .mygoods-title,
		.query-list {
			display: flex;
			justify-content: space-between;
			margin: 10px  0;
			padding: 10px 0;
			border-bottom: 1px #E0E0E0 solid;
		}
	
		.storepurchase .shop-choose {
			display: inline-block;
			margin-right: 15px;
		}
	
	
		.storepurchase .xinzhen{
			float: right;
		}
	
		.storepurchase .cirlle {
			position: absolute;
			top: -15px;
			left: -13px;
			display: block;
			width: 30px;
			height: 30px;
			background-color: red;
			border-radius: 50%;
			text-align: center;
			line-height: 30px;
			color: #fff;
		}
		.storeGoods .goods-title-desc{
			display: flex;
			flex-direction: column;
		
			margin:  0 10px;
		
		}
		.storepurchase  .mygoods-list-nodata{
			text-align: center;
			margin: 100px;
		}
		
		.storepurchase .Pager{
		position: fixed;
		bottom: 0;
		left: 225px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
		}
		.storepurchase .btn-wrapper{
			display: flex;
			flex-direction: column;
		}
		.storepurchase .btn-item-desc{
			
			width: 120px;
			margin: 5px 0;
			border: none !important;
		}
		
		.storepurchase .query-list-bbc{
			display: flex;
			
		}
		
		.storepurchase .header-top{
			position: fixed;
			width: calc(100% - 221px);
			top: 50px;
			background-color: #fff;
			z-index: 2;
			box-sizing: border-box;
			padding: 0 15px;
		}
		.storepurchase .mygoods-list{
			margin-top: 111px;
			margin-bottom: 110px;
			
		}
		.storepurchase .query-list-tcp{
			display: flex;
		}
		.storepurchase .skuName{
			color: red!important;
			font-size: 16px;
		}
		
		.storepurchase .el-input__inner{
			padding: 0 !important;
		}
		
		.visiableMessage_desc{
			line-height: 30px;
		}
		
	
		.vue-directive-image-previewer{
			z-index: 9999 !important;
		}
		
	
	
</style>
